import { Flex, Center, MenuButton, Button } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { FaRegBell } from "react-icons/fa";

export default function BadgeComponent({ count }: { count: number }) {
  const pulse = keyframes`
    0% { transform: scale(0.9); opacity: 0.7; }
    50% { transform: scale(1.2); opacity: 1; }
    100% { transform: scale(0.9); opacity: 0.7; }
  `;

  return (
    <Flex position="relative">
      <MenuButton
        as={Button}
        rounded={"full"}
        variant={"link"}
        cursor={"pointer"}
        minW={0}
      >
        <FaRegBell size={22} />

        {count > 0 && (
          <Center
            position="absolute"
            top="-20px"
            right="-10px"
            w="20px"
            h="20px"
            fontSize="11px"
            bg="red.500"
            color="white"
            rounded="full"
            animation={`${pulse} 1.2s infinite`}
            boxShadow="0 0 10px rgba(255,0,0,0.7)"
          >
            {count}
          </Center>
        )}
      </MenuButton>
    </Flex>
  );
}
